export { default } from './DetailedCarModal';
